/**
 * Compax rejects Vertragskonto changes (create, update, transfer) with this 403
 * while a bill run is active, for credit card customers, and for credit class C
 * with manual payment. The session is still valid.
 */
const BILLING_ACTION_BLOCKED_MESSAGE =
  "Action not allowed because of account settings or active billrun";

export const isBillingActionBlockedError = (err: unknown): boolean => {
  const response = (
    err as { response?: { status?: number; data?: unknown } } | null
  )?.response;

  if (response?.status !== 403) {
    return false;
  }

  const data =
    typeof response.data === "string"
      ? response.data
      : JSON.stringify(response.data ?? "");

  return data.includes(BILLING_ACTION_BLOCKED_MESSAGE);
};
